import log from "loglevel";
import prefix from "loglevel-plugin-prefix";
export const timestampFormatter = function (date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

    const offset = -date.getTimezoneOffset();
    const offsetHours = String(Math.floor(offset / 60)).padStart(2, '0');
    const offsetMinutes = String(Math.abs(offset % 60)).padStart(2, '0');
    const offsetSign = offset >= 0 ? '+' : '-';

    const timezoneOffset = `${offsetSign}${offsetHours}:${offsetMinutes}`;

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds} ${timezoneOffset}`;
};

prefix.reg(log);
prefix.apply(log, {
    timestampFormatter,
    format(level, name, timestamp) {
        return `[${level}] [${timestamp}]`;
    },
});
log.enableAll();
let Logger = log;
window.console = Logger;

export default Logger;